import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { useSearch } from '../contexts/SearchContext';

const Header: React.FC = () => {
  const { isDarkMode } = useTheme();
  const { setSearchTerm } = useSearch();

  const handleLogoClick = () => {
    setSearchTerm('');
  };

  return (
    <header className="header header-brand">
      <Link to="/" className="header-link" onClick={handleLogoClick}>
        <div className="header-logo">
          <img
            src={isDarkMode ? '/dark mode logo.png' : '/logo circle.png'}
            alt="Anglopi Logo"
            className="header-logo-img"
          />
        </div>
      </Link>
    </header>
  );
};

export default Header;
